import React from "react";

const SkillsMobile = ({ header, body }) => {
  return (
    <>
      <div
        style={{
          border: "2px solid #ABB2BF",
          height: "min-content",
          maxWidth: "300px",
          margin: "3% 0",
        }}
      >
        <div
          style={{ color: "white", textAlign: "center", fontWeight: "bolder" }}
        >
          <h2>{header}</h2>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            color: "#ABB2BF",
            border: "2px solid #ABB2BF",
          }}
        >
          {body}
        </div>
      </div>
    </>
  );
};

export default SkillsMobile;
